import { connect } from 'react-redux'
import { get } from 'lodash-es'
import { chatbotSelectors, chatbotEvents, getStep, PortfolioWizardStepNames } from '../../../modules/ui/ChatBot'
import { ChatBot } from '../../components'

const mapStateToProps = (state, { push }: any) => ({
  step: getStep(PortfolioWizardStepNames.activation),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Activation summary',
  description: 'Review what will happen when you activate this lease. This action cannot be undone.',
  displayDescription: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  actions:
    chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress'
      ? [
          {
            text: 'Back',
            action: () => chatbotEvents.portfolioRedirect('/leases/:id/edit/settings'),
          },
          {
            text: 'Activate lease',
            className: 'activate',
            action: () => chatbotEvents.currentPortfolioActivationConfirmationTriggered(),
          },
        ]
      : [],
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (actionProvider: any) => {
    const action = actionProvider()
    if (get(action, 'type', false) || get(action, 'meta', false)) {
      dispatch(action)
    }
  },
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
